import { render, staticRenderFns } from "./AxChangeOwner.vue?vue&type=template&id=126ec0d4&scoped=true&"
import script from "./AxChangeOwner.vue?vue&type=script&lang=ts&"
export * from "./AxChangeOwner.vue?vue&type=script&lang=ts&"
import style0 from "./AxChangeOwner.vue?vue&type=style&index=0&id=126ec0d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ec0d4",
  null
  
)

export default component.exports